export let F7 = null;
export const initF7 = f7 => {
  F7 = f7;
};
